export const API_KEY = "AIzaSyBqJ0VaaKzEyC2o-x9HUZC6hEtEJObPcFA";
